interface RaisedInformallyIconProps {
  className?: string
}

export const RaisedInformallyIcon = ({
  className,
}: RaisedInformallyIconProps) => {
  return (
    <svg
      width='29'
      height='25'
      viewBox='0 0 29 25'
      fill='none'
      className={`rounded p-1 bg-[#37A2BA] ${className}`}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='icon'>
        <path
          id='Ellipse 98 (Stroke)'
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M6.37198 12.3782C6.37198 10.3497 6.97349 8.36677 8.10046 6.68014C9.22742 4.99352 10.8292 3.67895 12.7033 2.90269C14.5774 2.12642 16.6396 1.92331 18.6291 2.31905C20.6186 2.71478 22.4461 3.69159 23.8804 5.12595C25.3148 6.5603 26.2916 8.38779 26.6873 10.3773C27.0831 12.3668 26.8799 14.429 26.1037 16.3031C25.3274 18.1771 24.0129 19.7789 22.3262 20.9059C20.6396 22.0329 18.6567 22.6344 16.6282 22.6344C16.0422 22.6344 15.5672 23.1094 15.5672 23.6954C15.5672 24.2813 16.0422 24.7564 16.6282 24.7564C19.0764 24.7564 21.4696 24.0304 23.5051 22.6703C25.5407 21.3101 27.1273 19.3769 28.0641 17.1151C29.001 14.8533 29.2461 12.3645 28.7685 9.96332C28.2909 7.56219 27.112 5.35661 25.3809 3.62549C23.6498 1.89437 21.4442 0.71546 19.043 0.237845C16.6419 -0.239769 14.1531 0.00536088 11.8913 0.942237C9.62944 1.87911 7.69623 3.46566 6.3361 5.50124C4.97597 7.53682 4.25 9.93001 4.25 12.3782C4.25 12.9642 4.72502 13.4392 5.31099 13.4392C5.89696 13.4392 6.37198 12.9642 6.37198 12.3782Z'
          fill='white'
        />
        <path
          id='Vector 301 (Stroke)'
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M0.310756 8.80685C-0.103585 9.22119 -0.103585 9.89297 0.310756 10.3073L4.05455 14.0511C4.74512 14.7417 5.86475 14.7417 6.55532 14.0511L10.2991 10.3073C10.7135 9.89297 10.7135 9.22119 10.2991 8.80685C9.88477 8.39251 9.21299 8.39251 8.79865 8.80685L5.30493 12.3006L1.81122 8.80685C1.39688 8.39251 0.725097 8.39251 0.310756 8.80685Z'
          fill='white'
        />
        <path
          id='Vector 428 (Stroke)'
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M15.9204 5.66406C16.5063 5.66406 16.9813 6.13908 16.9813 6.72505V13.2884L20.1198 15.7991C20.5773 16.1652 20.6515 16.8328 20.2855 17.2904C19.9194 17.748 19.2518 17.8221 18.7942 17.4561L15.3107 14.6693C15.0254 14.4411 14.8594 14.0956 14.8594 13.7303V6.72505C14.8594 6.13908 15.3344 5.66406 15.9204 5.66406Z'
          fill='white'
        />
      </g>
    </svg>
  )
}
